import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useDisplay, useTheme } from "vuetify";

export const useThemeStore = defineStore("theme", () => {
  const theme = useTheme();
  const display = useDisplay();

  // Default to light; user preference persists in localStorage.
  //
  // 作業マニュアルの閲覧・印刷・PDF 出力が中心で、ドキュメントは A4 用紙を
  // 模した白基調（PublicManualDocument.vue の .document-paper）。ブランドロゴも
  // 白背景前提で作られている。ダーク既定は poranos（3D/VR ビューア中心）から
  // 引き継いだもので、このアプリの性格には合わない。
  //
  // localStorage に書くのは toggleTheme() だけなので、保存値を持つのは自分で
  // 切り替えたユーザーだけ。その選択はここでは上書きしない。
  const isDarkMode = ref(
    localStorage.getItem("darkMode") !== null
      ? localStorage.getItem("darkMode") === "true"
      : false,
  );
  theme.global.name.value = isDarkMode.value ? "dark" : "light";

  function toggleTheme() {
    isDarkMode.value = !isDarkMode.value;
    localStorage.setItem("darkMode", isDarkMode.value);
    theme.global.name.value = isDarkMode.value ? "dark" : "light";
  }

  const isMobile = computed(() => display.smAndDown.value);

  // Public Manual pages set this so the AppBar / NavigationDrawer hide.
  const isPublicView = ref(false);
  function setPublicView(flag = true) {
    isPublicView.value = flag;
  }

  const hideMenuBar = ref(false);
  function setHideMenuBar(flag = true) {
    hideMenuBar.value = flag;
  }

  return {
    isDarkMode,
    toggleTheme,
    isMobile,
    isPublicView,
    setPublicView,
    hideMenuBar,
    setHideMenuBar,
  };
});
